var map = {
	"./locales.countries.de": 40,
	"./locales.countries.de.js": 40,
	"./locales.countries.nl": 41,
	"./locales.countries.nl.js": 41,
	"./locales.de": 79,
	"./locales.de.js": 79,
	"./locales.en": 278,
	"./locales.en.js": 278,
	"./locales.nl": 80,
	"./locales.nl.js": 80,
	"./locales.pl": 279,
	"./locales.pl.js": 279
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;


//////////////////
// WEBPACK FOOTER
// ./src/js/lang ^\.\/locales\..*$
// module id = 81
// module chunks = 234